const ip = process.env.VUE_APP_API_URL

if (!ip) {
    throw new Error(
        'VUE_APP_API_URL no esta definida. Verificar que el build corra con --mode development ' +
        '(usa .env.development) o que .env.production tenga la URL del back antes de compilar.'
    )
}

module.exports = ip
